import {
  useMutation,
  type MutationFunctionOptions,
  type FetchResult,
  gql,
} from '@apollo/react-hooks';

export const useLogin = (): ((
  options?: MutationFunctionOptions,
) => Promise<FetchResult>) => {
  const [login] = useMutation(gql`
    mutation ($username: String!, $password: String!, $captcha: CaptchaInput) {
      logIn(username: $username, password: $password, captcha: $captcha) {
        access_token
      }
    }
  `);

  return login;
};
